import React from 'react';

const About = () => {
  const team = [
   {
  name: 'Dr. Priya',
  position: 'Founder & Chief Radiologist',
  bio: `Dr. Priya Singh
Consultant Radiologist | MBBS, DMRD, DNB (Radiology)

Dr. Priya Singh is a board-certified radiologist with extensive experience in diagnostic imaging. She has served at leading healthcare institutions including Manipal Hospital Sarjapur, Apollo Clinic HSR Layout, Rainbow Children’s Hospital Bannerghatta, and Aarthi Scans & Labs, Jayanagar.

She earned her MBBS and Radiology degree from Mahatma Gandhi Institute of Medical Sciences, Sewagram (Maharashtra), and completed her DNB in Radiology at Action Cancer Hospital, New Delhi.

Dr. Priya is highly skilled in X-ray, Ultrasound (USG), CT, and MRI scans, with a special focus on women’s imaging, musculoskeletal (MSK) imaging, and oncology imaging. Known for her patient-centric approach, she combines clinical precision with compassion to deliver high-quality, accurate diagnoses.

Her vision is to promote preventive healthcare and ensure accessible, affordable, and quality health services for all — empowering individuals through early detection and timely care.`,
  image: 'images/team/priya-doc.png'
}
  ];
  
// https://images.unsplash.com/photo-1666214280352-db292c05fd80
// https://images.unsplash.com/photo-1666214282459-c7dff167ecc0
// https://images.unsplash.com/photo-1630531210843-d6f343ad1f90

  const gallery = [
    {
      image: 'images/services/Ultrasound.jpg',
      title: 'Ultrasound'
    },
    {
      image: 'images/services/x-ray.jpg',
      title: 'X-Ray'
    },
    {
      image: 'images/services/Echo.jpg',
      title: 'ECHO'
    },
    {
      image: 'images/services/ECG.png',
      title: 'ECG (Electrocardiogram)'
    },
    {
      image: 'images/services/waitingarea.jpeg',
      title: 'Patient Waiting Area'
    },
    {
      image: 'images/services/reception.jpeg',
      title: 'Reception'
    }
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-1/2 lg:pr-10 mb-10 lg:mb-0">
              <h1 className="text-4xl font-bold text-gray-900 mb-4">About YANA Health</h1>
              <div className="w-20 h-1 bg-yana-orange mb-6"></div>
              <p className="text-lg text-gray-600 mb-6">
                YANA Health Scans & Labs was founded with a simple but powerful mission: 
                to provide high-quality diagnostic imaging services in an environment where 
                patients feel supported, informed, and never alone.
              </p>
              <p className="text-lg text-gray-600 mb-6">
                Our name, YANA, stands for "You Are Not Alone," reflecting our commitment to 
                being there for our patients every step of the way. We understand that medical 
                procedures can be intimidating, so we strive to create a warm, welcoming 
                atmosphere where your comfort is prioritized.
              </p>
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4 border-yana-orange">
                <h2 className="text-xl font-semibold text-gray-800 mb-2">Our Mission</h2>
                <p className="text-gray-600">
                  To provide accessible, high-quality diagnostic imaging services with compassion, 
                  expertise, and the latest technology, ensuring every patient feels supported 
                  throughout their healthcare journey.
                </p>
              </div>
            </div>
            <div className="lg:w-1/2">
              <img 
                src="images/Logos/YANA_Secondary Logo.png" 
                alt="YANA Health" 
                className="rounded-lg shadow-xl w-full h-auto object-cover overflow-hidden p-4"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Core Values</h2>
            <div className="w-20 h-1 bg-yana-orange mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg text-center hover:shadow-md transition-shadow">
              <div className="bg-yana-orange bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-heart text-2xl text-yana-orange"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Compassion</h3>
              <p className="text-gray-600">
                We treat every patient with kindness, empathy, and respect, recognizing their individual needs and concerns.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg text-center hover:shadow-md transition-shadow">
              <div className="bg-yana-orange bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-microscope text-2xl text-yana-orange"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Excellence</h3>
              <p className="text-gray-600">
                We strive for the highest standards in all aspects of our service, from technology to patient care.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg text-center hover:shadow-md transition-shadow">
              <div className="bg-yana-orange bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-lock text-2xl text-yana-orange"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Integrity</h3>
              <p className="text-gray-600">
                We operate with honesty, transparency, and ethical standards in all our interactions.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg text-center hover:shadow-md transition-shadow">
              <div className="bg-yana-orange bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-2xl text-yana-orange"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Support</h3>
              <p className="text-gray-600">
                We ensure that every patient feels supported, informed, and never alone throughout their experience with us.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
            <div className="w-20 h-1 bg-yana-orange mx-auto mb-6"></div>
            <p className="max-w-2xl mx-auto text-lg text-gray-600">
              Our dedicated team of professionals is committed to providing the highest quality care.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden group hover:shadow-xl transition-shadow">
                <div className="h-72 overflow-hidden">
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-1">{member.name}</h3>
                  <p className="text-yana-orange font-medium mb-4">{member.position}</p>
                  <p className="text-gray-600">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      
  {/* Our Team */}

  <section className="py-20 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
  <div className="container mx-auto px-6">
    <div className="text-center mb-24"> {/* Increased bottom margin for spacing */}
      <h2 className="text-4xl font-extrabold text-gray-900 mb-3">Meet Our Team</h2>
      <div className="w-24 h-1 bg-gradient-to-r from-orange-400 to-yellow-500 rounded mx-auto mb-6"></div>
      <p className="max-w-xl mx-auto text-lg text-gray-600">
        Our dedicated team of professionals is committed to providing the highest quality care with compassion and precision.
      </p>
    </div>

    <div className="max-w-3xl mx-auto relative group mt-24 xs:mt-28 sm:mt-32 md:mt-36 lg:mt-40">
      {team.map((member, index) => (
        <div
          key={index}
          className="group relative z-10 bg-white rounded-3xl shadow-xl border border-gray-100 transition duration-300 px-6 pt-28 pb-10 text-center overflow-visible"
        >
          {/* Profile Picture */}
          <div className="absolute -top-28 left-1/2 transform -translate-x-1/2">
            <div className="transition-transform duration-500 ease-in-out group-hover:scale-[1.5] transform origin-center">
              <div className="w-44 h-44 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-orange-100 shadow-md bg-white">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Name & Role */}
          <h3 className="text-3xl font-bold text-gray-800 mt-6">{member.name}</h3>
          <p className="text-orange-500 font-semibold text-lg mt-2">{member.position}</p>
         <div className="mt-4 space-y-3 text-gray-600 leading-relaxed">
                 <p className="font-semibold text-lg text-gray-800">
                   {member.bio.split("\n")[0]}
                  </p>
                    {member.bio.split("\n").slice(1).map((para, idx) => (
                  <p key={idx}>{para}</p>
                              ))}
                    </div>

          {/* Decorative Glow */}
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <div className="absolute top-0 right-0 w-40 h-40 bg-orange-100 rounded-full blur-3xl opacity-30 transform translate-x-1/3 -translate-y-1/3"></div>
            <div className="absolute bottom-0 left-0 w-32 h-32 bg-yellow-200 rounded-full blur-2xl opacity-20 transform -translate-x-1/2 translate-y-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>





      {/* Facility Gallery */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Facility</h2>
            <div className="w-20 h-1 bg-yana-orange mx-auto mb-6"></div>
            <p className="max-w-2xl mx-auto text-lg text-gray-600">
              Take a virtual tour of our state-of-the-art facility and equipment.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {gallery.map((item, index) => (
              <div key={index} className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <h3 className="text-white text-xl font-medium">{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;